import React, { Component } from 'react';
import './student-detail.scss';
import { ImageConstants, Constants } from '../../../../../constants/constants';
import { getImageSource } from '../../../../../utility/image-source'
import CwContentViewer from '../../../../common/cw-content-viewer/cw-content-viewer'
import CanvasPreview from '../../../../common/canvas/canvas'
import GeometryTranspiler from '../../../../common/geometry/geometry-parser'
import Dropdown from '../../../../common/dropdown-v2/dropdown';
import Loading from '../../../../../components/common/loading/loading'
import HomeworkApi from '../../../../../apis/homework'


class StudentDetailReport extends Component {

    constructor(props) {
        super(props)

        this.state.selectedAction = this.props.selectedAction;

    }
    state = {

        dropdownData: [
            {
                title: 'Correct',
                value: 'CORRECT'
            },
            {
                title: 'Incorrect',
                value: 'IN_CORRECT'
            },
        ],
        questions: [],
        isLoading: true,
        selectedStatus: []
    }


    componentDidMount() {
        this.getStudentDetailReport()
        document.addEventListener('mousedown', this.handleClickEvent, false);
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickEvent, false);
    }


    getStudentDetailReport(payload = {}) {


        if (this.props.selectedItem) {
            payload.homeworkId = this.props.selectedItem?._id
        }

        if (this.props.student) {
            payload.studentId = this.props.student?.userId
        }

        this.setState({ isLoading: true })

        HomeworkApi.getStudentDetailReport(payload)
            .then(response => {

                this.setState({
                    activity: response.activity,
                    questions: response.questions,
                    backupQuestions: response.questions,
                    isLoading: false
                })

            }).catch(err => {
                this.setState({ isLoading: false })
            })
    }

    getDate = (timeStamp, getYear) => {

        let dateFormat = new Date(timeStamp).toDateString();

        let date = dateFormat.split(" ")[2];

        let month = dateFormat.split(" ")[1];

        let year = dateFormat.split(" ")[3];

        if (getYear) {
            return date + " " + month + " " + year;
        } else {
            return date + " " + month;
        }
    }

    renderBreadcrumb = () => {
        return (
            <div className='breadcrumb-1'>
                <span>{`${this.props.selectedItem?.class} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.section || ""} >`}</span>
                <span className='pl-2'>{`${this.props.selectedItem?.chapter} >`}</span>
                <span className='pl-2'>{this.getDate(this.props.selectedItem?.createdDateTimestamp)}</span>
            </div>
        )
    }

    renderResultColor = (result) => {

        switch (result) {
            case 'CORRECT':
                return '#4CCAB7'

            case 'IN_CORRECT':
                return '#FF7171'

            default:
                return '#FFC571'
        }

    }

    renderResultText = (result) => {

        switch (result) {
            case 'CORRECT':
                return 'Correct'

            case 'IN_CORRECT':
                return 'Incorrect'

            default:
                return ''
        }

    }

    onClickBack = () => {
        this.props.onClickBack && this.props.onClickBack()
    }

    onSaveEditMark = (item, index) => {

        if (!this.state.edittedMark) {
            this.setState({ errorMessage: "Please Enter Mark" })
            return
        }

        let list = this.state.questions

        list[index].finalMarks = this.state.edittedMark

        this.setState({ questions: list }, () => {
            this.setState({ edittedMark: "", editMark: false })
        })
    }

    changeMark = (index) => {
        this.setState({ editMark: true, selectedIndex: index })
    }

    closeEditMark = () => {
        this.setState({ editMark: false })
    }

    onChangeHandler = (value, item, index) => {
        this.setState({ edittedMark: value })
    }

    onSelectDropDown(option, key) {
        let status = this.state.selectedStatus
        if (this.state.selectedStatus.includes(option.value)) {
            status = this.state.selectedStatus.filter(item => item != option.value)
        } else {
            status.push(option.value)
        }
        this.setState({ selectedStatus: status })
    }

    onApplyFilter = () => {
        let status = this.state.selectedStatus
        if (!status.length) {
            this.setState({ questions: this.state.backupQuestions })
        } else {
            let questions = this.state.backupQuestions.filter(item => {
                return status.includes(item.status)
            })
            this.setState({ questions })
        }

        this.setState({ showFilter: false })

    }

    handleClickEvent = (event) => {
        if (this.filterRef && !this.filterRef.contains(event.target)) {
            if (this.state.showFilter) {
                this.setState({ showFilter: false })
            }
        }
    }

    render() {

        return (
            <>
                {this.state.isLoading && <Loading />}
                <div className='student-detail-1'>

                    {/* <div className='container-1'>
                        <div className='mb-3 item1' >
                            <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                        </div>
                        <div className='item-2'>
                            <span className='screen-title title-center my-5'>Student Performance</span>
                        </div>
                    </div>

                    <span>{this.renderBreadcrumb()}</span> */}
                    <div className='mb-3 item1' >
                            <img className='back-icon cursor-pointer' src={getImageSource(ImageConstants.BACK_ICON)} onClick={() => this.onClickBack()} />
                        </div>
                        <div className='d-flex align-items-center justify-content-between header-report-card mb-3'>
                        <div className='d-flex align-items-center'>
                            <div>
                                <img className='circle-image' src={getImageSource(ImageConstants.EVALUATION_DETAIL_REPORT)} />
                            </div>
                            <div className='ml-2'>
                                <div className=''>
                                    <span className='screen-title-1'>Student Performance</span>
                                    <span>{this.renderBreadcrumb()}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='flex'>
                        <div className='ml-4 student-test-info-card'>
                            <div className='user-image'>
                                {
                                    this.props?.student?.image ?
                                        <img className="user-image" alt="img" src={`${this.props?.student?.basePath}${this.props?.student?.image}`} />
                                        :
                                        <img className="user-image" alt="img" src={Constants.ALTERNATE_STUDENT_IMAGE} />
                                }
                            </div>
                            <div className="pl-4">
                                <div className="stduent-name">{this.props?.student?.name}</div>
                                <div className='roll-no'>Roll No : {this.props?.student?.rollNumber}</div>
                            </div>
                            <div className='ml-5'>
                                <div className='marks-card'>
                                    <div>
                                        <div className='student-name text-center'>{this.state?.activity?.mark || 0}</div>
                                        <div className='roll-no'>Marks</div>
                                    </div>
                                </div>
                            </div>

                            <div className='ml-4'>
                                <div className='answered-card'>
                                    <div>
                                        <div className='row'>
                                            <div className='dot green-dot'></div>
                                            <span className='roll-no'>{this.state?.activity?.correct || 0} Correct</span>
                                        </div>
                                        <div className='row'>
                                            <div className='dot red-dot'></div>
                                            <div className='roll-no'>{this.state?.activity?.incorrect || 0} In-Correct</div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row mr-2">
                        <div className="col text-right  py-2 px-4">
                            <span className="filter-input-label pr-2">
                                Filter
                            </span>
                            <img className="filter-image cursor-pointer" src={getImageSource(ImageConstants.FILTER)} onClick={() => this.setState({ showFilter: true })} />

                            {
                                this.state.showFilter ?
                                    <span className="cw-card status-filter text-left" ref={ref => this.filterRef = ref}>
                                        <div className="pt-2 result-text"><b> Result </b></div>
                                        {
                                            this.state.dropdownData.map(item => (
                                                <div className='py-2 cursor-pointer' onClick={() => this.onSelectDropDown(item)}>
                                                    {
                                                        this.state.selectedStatus.includes(item.value)
                                                            ?
                                                            <img className="check-box-image" src={getImageSource(ImageConstants.ACTIVE_TICK)} />
                                                            :
                                                            <img className="check-box-image" src={getImageSource(ImageConstants.RECT_BLACK)} />
                                                    }
                                                    <span className="pl-2">{item?.title}</span>
                                                </div>
                                            ))
                                        }
                                        <div className='text-center mt-4 mb-2'>
                                            <span className="apply-button text-center" onClick={this.onApplyFilter}> Apply</span>
                                        </div>
                                    </span>

                                    : ""
                            }
                        </div>

                    </div>

                    {
                        <div className='report-card-wrapper ml-4 mr-2'>

                            <div id="table-scoll" className="table-responsive" style={{background: "rgb(245, 246, 250)",
    border: "1px solid rgb(245, 246, 250)"}}>
                                <table className="table cw-table custom-report-table  align-items-center ">
                                    <thead>
                                        <tr>
                                            <th className='th-left-radius pl-4'>Question</th>
                                            <th className='text-center percentage'>Marks</th>
                                            <th className='text-center percentage'>Result</th>
                                            <th className='th-right-radius text-center percentage'> % Students <br />- Correct </th>
                                        </tr>
                                    </thead>
                                    <tbody className="bg-white">
                                        {
                                            this.state.questions && this.state.questions.length ? this.state.questions?.map((item, index) => (

                                                <tr key={item.id} className="mt-4 ">
                                                    <td>
                                                        <div className='row ml-3'>
                                                            <div className='mt-1'>{index + 1}</div>
                                                            <div className="qn-title-card ml-2 mr-4">{item.content.title ? <CwContentViewer content={item.content.title} /> : ""}</div>
                                                        </div>
                                                    </td>
                                                    <td className='text-center percentage'>{item?.marks}</td>
                                                    <td className='text-center percentage' style={{ color: this.renderResultColor(item.status) }}><b>{this.renderResultText(item?.status)}</b></td>
                                                    <td className='percentage text-center'>{item?.correctPercentage} %</td>
                                                </tr>
                                            ))
                                                : <tr className="bg-white pt-4"><td colSpan="11" align='center'>No Records found</td></tr>
                                        }
                                    </tbody>
                                </table>
                            </div >
                        </div>

                    }
                </div >
            </>
        );
    }
}

export default StudentDetailReport;